export * from './services/competitor-shops-resolver.service';
export * from './services/editable-shop-resolver.service';